import * as ActionTypes from './ActionTypes'
import { Map } from 'immutable'
import { CFD_POS_PAYMENT_FLOWS } from './Enums'

// ON DEPRECATION NOTICE
export const CFD_SCREEN = {
  IDLE: 'IDLE',
  CART: 'CART',
  BALANCE_AVAILABLE: 'BALANCE_AVAILABLE',
  CARD_PAYMENT: 'CARD_PAYMENT',
  RICH_CHECKOUT: 'RICH_CHECKOUT',
  RECEIPT: 'RECEIPT',
  PROCESSING: 'PROCESSING',
  CARD_DECLINED: 'CARD_DECLINED',
  RICH_CHECKOUT_QR_CODE: 'RICH_CHECKOUT_QR_CODE',
  RICH_CHECKOUT_SCAN_QR_CODE: 'RICH_CHECKOUT_SCAN_QR_CODE',
  RICH_CHECKOUT_FINISH_TRANSACTION_ON_PHONE: 'RICH_CHECKOUT_FINISH_TRANSACTION_ON_PHONE',
  RICH_CHECKOUT_SHOW_RECEIPT: 'RICH_CHECKOUT_SHOW_RECEIPT',
  SPLIT_PAY_WAITING_FOR_ATTENDANT: 'SPLIT_PAY_WAITING_FOR_ATTENDANT',
  PRESENT_QR_PAY_CODE: 'PRESENT_QR_PAY_CODE',
  BALANCE_DUE: 'BALANCE_DUE',
  TRANSACTION_SUMMARY: 'TRANSACTION_SUMMARY',
  TICKET_PAYMENT: 'TICKET_PAYMENT',
  GIFT_CARD_PAYMENT: 'GIFT_CARD_PAYMENT',
  TICKET_PAYMENT_BALANCE: 'TICKET_PAYMENT_BALANCE',
  CHARITY: 'CHARITY',
  TRANSACTION_ERROR: 'TRANSACTION_ERROR',
}

const getInitialState = () => {
  return Map({
    executeSalesRequest: Map({}), // the details about executing the sales request on the POS from the CFD
    orderDetails: Map({}),
    paymentProgress: Map({}),
    canExecuteSalesRequest: true,
    availableBalance: '',
    currentPaymentFlow: CFD_POS_PAYMENT_FLOWS.UNSET,

    // temporary state
    calculatedCurrentCartValues: {},
    formattedCart: {},
    currentTransactionLifecycle: '',

    // Message communication tracking
    currentMessageUuid: null,

    printStatus: Map({}),
    isCfdWebViewLoaded: false,
    isPaired: true,
    tempCFDScreen: null,
  })
}

const reducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case ActionTypes.VNCFD_RICH_CHECKOUT_ORDER_DETAILS:
      return state.set('orderDetails', action.data)
    case ActionTypes.VNCFD_SET_TEMP_SCREEN:
      return state.set('tempCFDScreen', action.screen)
    case ActionTypes.VNCFD_EXECUTE_SALES_REQUEST:
      return state.set('executeSalesRequest', Map(action.data))
    case ActionTypes.VNCFD_USER_PAYMENT_PROGRESS:
      return state.set('paymentProgress', action.data)
    case ActionTypes.VN_CAN_EXECUTE_SALES_REQUEST:
      return state.set('canExecuteSalesRequest', action.data)
    case ActionTypes.VNCFD_CURRENT_PAYMENT_FLOW:
      return state.set('currentPaymentFlow', action.currentFlow)
    case ActionTypes.VNCFD_UPDATE_TRANSACTION_LIFECYCLE:
      return state.set('currentTransactionLifecycle', action.moment)
    case ActionTypes.VNCFD_CALCULATED_CURRENT_CART_VALUES:
      return state.set('calculatedCurrentCartValues', action.cart)
    case ActionTypes.VNCFD_UPDATE_FORMATTED_CART:
      return state.set('formattedCart', action.cartItems)
    case ActionTypes.VNCFD_SET_PRINT_STATUS:
      return state.set('printStatus', Map(action.data))
    case ActionTypes.VNCFD_SET_AVAILABLE_BALANCE:
      return state.set('availableBalance', action.availableBalance)
    case ActionTypes.VN_CFD_WEB_VIEW_LOADED:
      return state.set('isCfdWebViewLoaded', action.isLoaded)
    case ActionTypes.VN_SET_IS_PAIRED:
      return state.set('isPaired', action.isPaired)
    case ActionTypes.VN_SET_CURRENT_MESSAGE_UUID:
      return state.set('currentMessageUuid', action.uuid)
    // resets CFD state back to initial values
    case ActionTypes.VNCFD_RESET:
      return getInitialState().set('isCfdWebViewLoaded', state.get('isCfdWebViewLoaded')).set('isPaired', state.get('isPaired'))
    default:
      return state
  }
}

export default reducer
